export default __webpack_public_path__ + "static/media/rare_intel.5d86421f.png";